import { s as r } from "./shared.js";
import { u as s } from "./uid.js";
var a = r("keys"),
  e = function e(r) {
    return a[r] || (a[r] = s(r));
  };
export { e as s };